<template>
    <div class="mesa-trabajo">
        <div class="contenedor-login">
            <div class="primera-mitad">
                <div class="marca-sipaes">
                    <span class="marca-nombre">SIPAES</span>
                    <span class="marca-version">
                        <span class="marca-guion"></span>
                        <span class="marca-version-texto">Versión 2.0</span>
                        <span class="marca-guion"></span>
                    </span>
                </div>
                <h1>Ingresar</h1>
                <p class="subtitulo">Usa tu cuenta institucional <strong>@udi.edu.co</strong></p>
                <div class="button">
                    <button class="btn google" @click.prevent="ingresoGoogle" :disabled="cargando">
                        <svg v-if="!cargando" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" class="google-icon">
                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                            <path fill="none" d="M0 0h48v48H0z"/>
                        </svg>
                        <span v-if="cargando">Ingresando...</span>
                        <span v-else>Ingresar con Google</span>
                    </button>
                </div>
                <p v-if="feedback" class="feedback-error">{{ feedback }}</p>
            </div>
            <div class="segunda-mitad">
                <img src="@/assets/udi-logo.png" alt="imagen centrada" class="imagen-centrada" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
/**
 * Pantalla de acceso.
 *
 * El único método real es el popup de Google: el backend valida un ID token de
 * Firebase en cada petición. Además, `LoginFirebaseService` restringe el acceso
 * al dominio institucional.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/Ingreso` (Ingreso) — sin permiso específico
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { ref } from 'vue';
import useAutenticar from '@/store/IngresoAutenticar';
import router from '@/router';

const store = useAutenticar()
const feedback = ref('')
const cargando = ref(false)

const ingresoGoogle = async () => {
    feedback.value = ''
    cargando.value = true
    const resultado = await store.loginGoogle()
    cargando.value = false

    if (!resultado.ok) {
        feedback.value = resultado.error ?? 'Error al ingresar'
    } else {
        router.push({ name: 'Dashboard' })
    }
}
</script>

<style scoped>
.mesa-trabajo {
  height: 100vh;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  box-sizing: border-box;
  line-height: var(--line-height-normal);
}

.contenedor-login {
  background-color: white;
  border-radius: var(--radius-lg);
  width: 820px;
  max-width: calc(100vw - 3rem);
  height: 560px;
  max-height: calc(100vh - 3rem);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 20px rgba(0, 0, 0, 0.1);
  font-family: var(--font-family);
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.primera-mitad {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(1.25rem, 3vw, 2.75rem);
  box-sizing: border-box;
}

.primera-mitad h1 {
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: var(--line-height-tight);
}

.marca-sipaes {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
}

.marca-nombre {
  font-family: var(--font-family);
  font-size: 2.25rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: var(--line-height-tight);
  color: #0e69a0;
}

.marca-version {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.35rem;
}

.marca-guion {
  height: 2px;
  width: 26px;
  background-color: #FDCB0C;
  display: inline-block;
}

.marca-version-texto {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #5F5E5A;
}

.segunda-mitad {
  flex: 1;
  background-color: #FDCB0C;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: clamp(1.25rem, 3vw, 2.75rem);
  box-sizing: border-box;
}

.imagen-centrada {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
}


.subtitulo {
  font-size: var(--font-size-sm);
  color: #666;
  margin-bottom: 2rem;
  text-align: center;
}

.button {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  height: 48px;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.google {
  background-color: white;
  color: #444;
  border: 1px solid #ddd;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
}

.btn.google:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: #f7f7f7;
}

.google-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.feedback-error {
  margin-top: 1rem;
  color: #c0392b;
  font-size: var(--font-size-sm);
  text-align: center;
}
</style>